import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthImagePipe } from './auth_image.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [AuthImagePipe],
    exports: [AuthImagePipe],
})
export class PipesModule {}
